import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue'
import { getResultAPI } from '@/api/mt/index'
import TranslateContent from './components/TranslateContent.vue'
import { MessageBox } from 'element-ui'
import { IMtRes } from '@/api/mt/type'

export default /*#__PURE__*/_defineComponent({
  __name: 'Result',
  props: {
  fileId: {
    type: String,
    required: true
  }
},
  emits: ['back-to'],
  setup(__props, { emit }) {

const props = __props




const translateRes = ref<IMtRes.ITranslateRes>({} as IMtRes.ITranslateRes)
const translateRef = ref()

const isEdit = ref(false)
function handleEdit (v: boolean) {
  isEdit.value = v
}
function handleBack () {
  if (isEdit.value) {
    MessageBox.confirm('是否保存更改内容', '提示', {
      distinguishCancelAndClose: true,
      confirmButtonText: '保存',
      cancelButtonText: '不保存',
      type: 'warning'
    }).then(() => {
      translateRef.value.handleSave()
      emit('back-to')
    }).catch((action) => {
      if (action === 'cancel') emit('back-to')
    })
  } else {
    emit('back-to')
  }
}

async function getResult () {
  let { data } = await getResultAPI({ id: props.fileId as string })
  translateRes.value = data
  translateRes.value.segments.forEach((item) => {
    item.origin = item.origin.replace(/<&>/g, '<br>')
    item.translated = item.translated.replace(/<&>/g, '<br>')
  })
}
getResult()

return { __sfc: true,emit, props, translateRes, translateRef, isEdit, handleEdit, handleBack, getResult, TranslateContent }
}

})